import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Text } from '@components/common';
import { HeadLine } from '@components/Typography';
import AnimatedTabs from '@components/AnimatedTabs';
import SvgIcon from '@components/SvgIcon';
import theme from '@styles/theme';
import { SERVICE_TYPES } from '@services/minte';

const List = styled(Box)`
  flex: 1;
  &::-webkit-scrollbar {
    width: 6px;
    background: ${theme.colors.secondary};
  }
  &::-webkit-scrollbar-thumb {
    width: 100%;
    border-radius: 30px;
    background: ${theme.colors.black};
  }
`;

const ALLOWED_SERVICES = [SERVICE_TYPES.HOTEL_STYLE, SERVICE_TYPES.DEEP_CLEAN];

const SERVICE_TITLES = {
  [SERVICE_TYPES.HOTEL_STYLE]: 'Hotel-style',
  [SERVICE_TYPES.DEEP_CLEAN]: 'Deep clean'
};

const SERVICE_DESCRIPTIONS = [
  [
    {
      title: 'FLOORS',
      services: [
        {
          item: 'MOP',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'VACUUM'
        },
        {
          item: 'BASEBOARDS',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        }
      ]
    },
    {
      title: 'BEDROOM',
      services: [
        {
          item: 'MAKE THE BED'
        },
        {
          item: 'STRAIGHTEN UP'
        },
        {
          item: 'EMPTY TRASH'
        },
        {
          item: 'MAKE BED/CHANGE SHEETS'
        },
        {
          item: 'DETAILED DUSTING',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        }
      ]
    },
    {
      title: 'KITCHEN',
      services: [
        {
          item: 'LOAD DISHWASHER'
        },
        {
          item: 'WIPE SINK'
        },
        {
          item: 'WIPE COUNTERS'
        },
        {
          item: 'WIPE STOVE TOP'
        },
        {
          item: 'EMPTY TRASH'
        },
        {
          item: 'POLISH CABINETS',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'SHINE APPLIANCES',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'CLEAN MICROWAVE',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        }
      ]
    }
  ],
  [
    {
      title: 'LIVING ROOM',
      services: [
        {
          item: 'TIDY'
        },
        {
          item: 'WIPE DOWN TABLETOPS'
        },

        {
          item: 'VACUUM UPHOLSTERY',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'DETAILED DUSTING & VENTS',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        }
      ]
    },
    {
      title: 'BATHROOM',
      services: [
        {
          item: 'STRAIGHTEN UP'
        },
        {
          item: 'FOLD/HANG TOWELS'
        },
        {
          item: 'EMPTY TRASH'
        },
        {
          item: 'WIPE DOWN COUNTERS, SINK, MIRROR',
          disabled: [SERVICE_TYPES.DEEP_CLEAN]
        },
        {
          item: 'EXTRA SCRUB OF COUNTERS, SINK, & MIRROR',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'WIPE SHOWER & BATH',
          disabled: [SERVICE_TYPES.DEEP_CLEAN]
        },
        {
          item: 'DEEP SCRUB SHOWER & BATH',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'CLEAN TOILET'
        },
        {
          item: 'POLISH CABINETS',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        },
        {
          item: 'MOP FLOOR'
        },
        {
          item: 'DETAILED DUSTING & VENTS',
          disabled: [SERVICE_TYPES.HOTEL_STYLE]
        }
      ]
    }
  ]
];

function HSvsDCDiff(props) {
  const [activeTabIndex, changeActiveTabIndex] = useState(0);

  const selectedServiceType = ALLOWED_SERVICES[activeTabIndex];

  return (
    <Box display="flex" flexDirection="column" {...props}>
      <AnimatedTabs
        segments={[
          SERVICE_TITLES[SERVICE_TYPES.HOTEL_STYLE],
          SERVICE_TITLES[SERVICE_TYPES.DEEP_CLEAN]
        ]}
        size="big"
        selectedIndex={activeTabIndex}
        onChange={(val, index) => {
          changeActiveTabIndex(index);
        }}
      />
      <Box display="flex" flexDirection="row">
        {SERVICE_DESCRIPTIONS.map((descGroup, index) => (
          <List key={index} overflow="auto">
            {descGroup.map(obj => {
              const { title, services } = obj;
              return (
                <Box display="flex" flexDirection="column" key={title} mt={4}>
                  <Box display="flex" flexDirection="row">
                    <SvgIcon name="leaf" width={16} height={16} pr={1} mt={1} />
                    <HeadLine position="relative">{title}</HeadLine>
                  </Box>

                  <Box isplay="flex" flexDirection="column" pl={2}>
                    {services.map(service => {
                      const isDisabled =
                        service.disabled &&
                        service.disabled.includes(selectedServiceType);
                      return (
                        <Text
                          key={service.item}
                          fontSize={0}
                          color={isDisabled ? 'grayTint' : 'text'}
                        >
                          - {service.item}
                        </Text>
                      );
                    })}
                  </Box>
                </Box>
              );
            })}
          </List>
        ))}
      </Box>
    </Box>
  );
}

export default HSvsDCDiff;
